export default __webpack_public_path__ + "static/media/centralized.259f676b.png";